goog.provide("shadow.js.shim.module$src$svg$inform$lightbulb_coil_svg");
goog.provide("module$shadow_js_shim_module$src$svg$inform$lightbulb_coil_svg");
shadow.js.shim.module$src$svg$inform$lightbulb_coil_svg = shadow.js.nativeProvides["src/svg/inform/lightbulb-coil.svg"] = shadow$bridge("src/svg/inform/lightbulb-coil.svg");
module$shadow_js_shim_module$src$svg$inform$lightbulb_coil_svg.default = shadow.js.shim.module$src$svg$inform$lightbulb_coil_svg;
